const Howls = {}
export default Howls
